import { db } from '../firebase';
import firebase from '../firebase';

const PAGE_SIZE = 50;

export const getTickets = async ({ page = 1, pageSize = 20 } = {}) => {
  const snapshot = await db.collection('support_tickets').orderBy('createdAt', 'desc').get();
  const allTickets = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  const total = allTickets.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const validPage = Math.max(1, Math.min(page, totalPages));
  const startIndex = (validPage - 1) * pageSize;
  const items = allTickets.slice(startIndex, startIndex + pageSize);
  return { items, total, totalPages, page: validPage, pageSize };
};

export const getPrevTickets = async () => {
  return { items: [] };
};

export const updateTicket = async (id, data) => {
  return db.collection('support_tickets').doc(id).update({
    ...data,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  });
};

export const getTicketById = async (id) => {
  const doc = await db.collection('support_tickets').doc(id).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
};

export const getUnresolvedTicketCount = async () => {
  const snapshot = await db.collection('support_tickets').where('status', '==', 'open').get();
  return snapshot.size;
};
